import React, { createContext, ReactNode, useContext, useMemo } from 'react';

interface ReadonlyContextType {
  isReadonly: boolean;
}

const ReadonlyContext = createContext<ReadonlyContextType | undefined>(undefined);

interface ReadonlyProviderProps {
  children: ReactNode;
  readonly?: boolean;
}

export const ReadonlyProvider: React.FC<ReadonlyProviderProps> = ({ children, readonly = false }) => {
  const value: ReadonlyContextType = useMemo(() => ({ isReadonly: readonly }), [readonly]);

  return <ReadonlyContext.Provider value={value}>{children}</ReadonlyContext.Provider>;
};

export const useReadonly = (): ReadonlyContextType => useContext(ReadonlyContext) || { isReadonly: false };
